<script setup lang="ts">
import { useI18n } from "vue-i18n"

const { t } = useI18n({ useScope: "global" })
</script>

<template>
  <span id="credits-text-madeby" class="text-neutral-500">
    <i18n-t keypath="footer.madeBy" scope="global">
      <template #peerdbLink>
        <a id="credits-link-peerdb" href="https://gitlab.com/peerdb/peerdb" class="link">PeerDB</a>
      </template>
      <template #plast8Link>
        <a id="credits-link-plast8" href="https://plast8.si/" class="link">{{ t("footer.plast8") }}</a>
      </template>
    </i18n-t>
  </span>
</template>
